/** @format */

import React from "react";

const CoreValueCard = ({ img, title, content }) => {
  return (
    <div
      className="h-[400px] qhd:h-[600px] w-full bg-cover bg-center ph:rounded-xl cursor-pointer pvmax:max-ph:rounded-none"
      style={{
        backgroundImage: `url(${img})`, // Apply the background image
      }}
    >
      <div className="ph:rounded-xl w-full h-full bg-black bg-opacity-20  flex flex-col justify-start gap-2 pb-20">
        <div className="w-full mx-auto flex flex-col gap-4 p-4">
          <p className="text-white text-[2.5rem] font-bold w-[100%] qhd:text-[3rem] ">
            {title}
          </p>
          <p className="text-white text-[1.5rem]  qhd:text-[2rem] w-[100%]">
            {content}
          </p>
        </div>
      </div>
    </div>
  );
};

export default CoreValueCard;
